module.exports = __webpack_public_path__ + "static/media/circle-loader.c4c011ee.svg";